import { Config } from '../config';
import {
  BlockMappingValidationJob,
  BlockMappingValidationRouteFile,
  CreateBulkEventEditJobResponse,
} from '../interfaces';
import { downloadTextFile } from '../utils';
import { HttpService } from './http.service';

const path = `${Config.API}/api/v2/bulk-event-edit-jobs/block-mapping-validation`;

export abstract class BlockMappingValidationService {
  public static listRouteFiles = (): Promise<BlockMappingValidationRouteFile[]> => {
    return HttpService.fetchAuthorized(`${path}/route-files`).then((res) => res || []);
  };

  // Creates a block mapping validation job and returns a presigned URL the caller
  // must PUT the block-mapping CSV to before triggering the run.
  public static createJob = (otaFileIds: number[]): Promise<CreateBulkEventEditJobResponse> => {
    return HttpService.fetchAuthorized(path, {
      method: 'POST',
      body: JSON.stringify({ ota_file_ids: otaFileIds }),
    }).then((res) => res);
  };

  // Plain fetch — no Authorization header. S3 presigned PUT URLs must not include extra auth headers.
  public static uploadCsv = (presignedUrl: string, file: Blob): Promise<void> => {
    return fetch(presignedUrl, {
      method: 'PUT',
      body: file,
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`CSV upload failed with status ${res.status}`);
      }
    });
  };

  public static runJob = (jobUUID: string, force?: boolean): Promise<BlockMappingValidationJob> => {
    return HttpService.fetchAuthorized(`${path}/${jobUUID}`, {
      method: 'POST',
      body: JSON.stringify({ force: force ?? false }),
    }).then((res) => res);
  };

  public static getJob = (jobUUID: string): Promise<BlockMappingValidationJob> => {
    return HttpService.fetchAuthorized(`${path}/${jobUUID}`, { cache: 'no-store' }).then((res) => res);
  };

  public static downloadMissingCSV = async (job: BlockMappingValidationJob) => {
    const res = await HttpService.fetchAuthorizedFileWithFleet(`${path}/${job.bulk_event_edit_job_uuid}/missing-routes`);
    if (!res?.ok) {
      throw res;
    }

    const csv = await res.text();
    downloadTextFile(csv, `block-mapping-validation-${job.bulk_event_edit_job_uuid}.csv`);
  };
}
